import React, { useContext, useState, useEffect, useCallback } from "react";
import { Container, Grid, Box } from "@mui/material";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import StudentApplicationApproval from "./inc/StudentApplicationApproval";
import StudentApplicationReport from "./inc/StudentApplicationReport";
import StudentTestScores from "./inc/StudentTestScores";
import PlacementTestingForm from "./inc/PlacementTestingForm";
import EligibilityReport from "./inc/EligibilityReport";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { SchoolContext } from "../../../config/SchoolContext";
import StudentChangeForm from "./inc/StudentChangeForm";
import ApplicationDay from "./inc/ApplicationDay";
import { useTheme } from "@mui/material/styles";
import GetCoordIds from "../../CcpConstants/GetCoordIds";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { isSpecificFormVisible } from "../../../utils/formVisibility";
import { useAuth } from "../../../config/AuthContext";

const CcpSchoolAppsAndTesting = () => {
  const { schoolId } = useContext(SchoolContext);
  const { currentUser } = useAuth();
  const theme = useTheme();
  const linkColor = theme.palette.mode === "dark" ? "white" : "black";
  const formId = "ix25Z19hd05vXVjPivyG"; // Document ID in Firestore for forms configuration
  const [formData, setFormData] = useState({
    testForm: "",
    coursePlanning: "",
  });
  const [loadingForms, setLoadingForms] = useState(true);
  const [formsError, setFormsError] = useState(null);

  const {
    pathwayEmail,
    opEmail,
    loading: emailsLoading,
    error: emailsError,
  } = GetCoordIds(schoolId);

  const pageName = "Apps & Testing";
  const icon = faChartLine;

  const loadFormData = useCallback(async () => {
    try {
      const docRef = doc(db, "forms", formId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setFormData(docSnap.data());
      } else {
        setFormsError(new Error("No such document!"));
      }
    } catch (error) {
      setFormsError(error);
    } finally {
      setLoadingForms(false);
    }
  }, [formId]);

  useEffect(() => {
    loadFormData();
  }, [loadFormData]);

  if (emailsLoading || loadingForms) {
    return <div>Loading...</div>; // Or a more suitable loading indicator
  }

  if (emailsError || formsError) {
    return <div>Error: {(emailsError || formsError).message}</div>;
  }

  return (
    <Container maxWidth={false} sx={{ marginTop: "100px", width: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2}>
          <Grid item xs={4} sx={{ marginTop: "20px" }}>
            <StudentChangeForm
              schoolId={schoolId}
              pathwayEmail={pathwayEmail}
              opEmail={opEmail}
            />
          </Grid>
          {isSpecificFormVisible(
            formData,
            "testForm",
            currentUser?.school_name,
          ) && (
            <Grid item xs={4} sx={{ marginTop: "20px" }}>
              <PlacementTestingForm
                schoolId={schoolId}
                pathwayEmail={pathwayEmail}
                opEmail={opEmail}
              />
            </Grid>
          )}
          <Grid item xs={4} sx={{ marginTop: "20px" }}>
            <ApplicationDay
              schoolId={schoolId}
              pathwayEmail={pathwayEmail}
              opEmail={opEmail}
            />
          </Grid>
          <Grid item xs={6}>
            <StudentApplicationApproval
              schoolId={schoolId}
              linkColor={linkColor}
            />
          </Grid>

          <Grid item xs={12}>
            <EligibilityReport schoolId={schoolId} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpSchoolAppsAndTesting;
